/**
 *
 * Uses downloadBlob to create and download a file given a string.
 *
 * @param filename The name of the file to download
 * @param s The string that will the content of the file
 * @param type The MIME type of the output
 */
export default function downloadFile(filename: string, s: string, type: string) {
  const file = new Blob([s], { type });
  downloadBlob(filename, file);
}

/**
 * Download a string as a file by creating an objectURL, an anchor element, and invoking it.
 */
export function downloadBlob(filename: string, blob: Blob) {
  const a = document.createElement("a");
  const url = (URL as any).createObjectURL(blob);
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    document.body.removeChild(a);
    (URL as any).revokeObjectURL(url);
  }, 0);
}
